<template>
    <v-container fluid style="border-top: 2px solid #eaedf1">
        <v-card flat :loading="loading">
            <v-row  class="d-flex flex-row justify-space-between align-center">
                <v-col  md="1" lg="2">
            <v-btn
                icon
                text
                @click="$router.back()"
                class="ml-2"
            >
                <v-icon v-text="icons.mdiArrowLeft" size="30"></v-icon>
            </v-btn>
        </v-col>
        <v-col  md="8"  class="py-0">
            <v-card-title class="px-6 pb-0">
            <v-col
                cols="12 d-flex flex-column justify-center align-center font-weight-medium text-h4 pb-0"
                ><span>
                  
                    <span class=""> {{ multipleCoupon.gift_title }}</span>
                  

                  
                </span>
                <span
                        class=" text-h5 font-weight-regular mt-1 text-left"
                        >#{{ multipleCoupon.code }}</span
                    >
            </v-col>
            <v-spacer></v-spacer>
        </v-card-title>
        </v-col>
        <v-col  md="3" lg="2">
        </v-col>
        <v-col  md="12" lg="12">
            <v-toolbar flat>
                <ExportLinks
                    @exportCSV="exportFile({
                        coupon_id: Number(couponId),
                        })"
                    @deleteCSV="
                        deleteExportedFile(exportedFile.user_store_export_id)
                    "
                    :buttonStatusCSV="exportCsvStatus"
                    :urlCSV="
                        exportedFile && exportedFile.url ? exportedFile.url : ''
                    "
                    :createdAt="exportedFile ? exportedFile.created_at : ''"
                />
                <v-spacer></v-spacer>
                <v-col cols="12" sm="4" class="pa-0">
                    <b-search-field v-model="search"></b-search-field>
                </v-col>
            </v-toolbar>
            <b-data-table
                :headers="headers"
                :items="couponClaims"
                :page.sync="page"
                @page-sync="p=>page=p"
                :pagination="claimsPagination"
            >
            </b-data-table>
        </v-col>
        </v-row>
        
        </v-card>
    
    </v-container>
</template>

<script>
import {
    mdiCalendarMonth,
    mdiChat,
    mdiBell,
    mdiEmail,
    mdiLock,
    mdiEye,
    mdiCached,
    mdiEmailOutline,
    mdiMessageReplyTextOutline,
    mdiMessageTextOutline,
    mdiBellOutline,
    mdiArrowRight,
    mdiCheckCircle,
    mdiCloseCircle,
    mdiGift,
    mdiAccountGroup,
    mdiTextBox,
    mdiArrowLeft,
    mdiFilter,
    mdiRefresh,
    mdiFinance
} from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";

import translations from "@/utils/translations/loyaltyPanel/multipleCoupons";
import debounce from "lodash/debounce";
import ExportLinks from "@/components/general/ExportLinks.vue";

export default {
    name: "ViewCouponClaims",

    mixins: [translations],

    components: { ExportLinks },

    data() {
        return {
            icons: {
                mdiCalendarMonth,
                mdiChat,
                mdiBell,
                mdiEmail,
                mdiLock,
                mdiEye,
                mdiCached,
                mdiEmailOutline,
                mdiMessageReplyTextOutline,
                mdiMessageTextOutline,
                mdiBellOutline,
                mdiArrowRight,
                mdiCheckCircle,
                mdiCloseCircle,
                mdiAccountGroup,
                mdiGift,
                mdiTextBox,
                mdiArrowLeft,
                mdiFilter,
                mdiRefresh,
                mdiFinance,
            },
            page: 1,
            search: "",
            exportCsvStatus: 1,
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "isSuperAdmin",
            "superUser",
        ]),
        ...mapState("loyaltyPanel/multipleCoupons", [
            "couponClaims",
            "exportedFile",
            "claimsPagination",
            "multipleCoupons",
            "pagination"
        ]),

        multipleCoupon: {
            get() {
                return this.$store.state.loyaltyPanel.multipleCoupons.multipleCoupon;
            },
            set(val) {
                this.setMultipleCoupon(val);
            }
        },

        lang() {
            return this.$route.params.lang;
        },
        locale() {
            if (this.lang == "el") return "el-GR";
            if (this.lang == "it") return "it-IT";
            return "en-GB";
        },

        couponId() {
            return this.$route.params.coupon_id;
        },

        headers() {
            return [
                {
                    text: '#ID',
                    value: "coupon_claim_id",
                },
                {
                    text: this.translations.redeemedStore[this.lang],
                    value: "redeemed_store_name	",
                },
                {
                    text: this.translations.voucherCode[this.lang],
                    value: "voucher",
                },
               
                {
                    text: this.translations.redeemedAt[this.lang],
                    value: "redeemed_at	",
                },
                {
                    text: this.translations.validityPeriod[this.lang],
                    value: "expiration_date",
                },
            ];
        },
        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }
            if (this.showRewarded) {
                query += `rewarded=true&`
            }

            return query.slice(0, query.length - 1);
        },
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.replace({
                    query: {
                        page: 1,
                        ...this.$route.query
                    }
                });
                return
            }
          this.fetchData()
        },

        page(page) {
            this.$router.replace({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                this.getParticipants({
                    query: this.query,
                    id: this.couponId
                });
            } else {
                this.debouncedSearch();
            }
        },
        
        exportedFile(val) {
                if (val?.queue) {
                    this.exportCsvStatus = 2;
                     //checks for file queue every 10 secs once the export has begun
                    this.getExportedFileInterval = setInterval(this.getExportedFile, 10000);
                    

                } else {
                    this.exportCsvStatus = val ? 3 : 1;
                    //once the export is completed, stop interval
                    clearInterval(this.getExportedFileInterval)
                }
        },
       
    },

    methods: {
        ...mapActions("loyaltyPanel/multipleCoupons", [
            "getCouponClaims",
            "getExportedFile",
            "exportFile",
            "deleteExportedFile",
            "getItems",
        ]),
        ...mapMutations("loyaltyPanel/multipleCoupons", [
            "setMultipleCoupon"
        ]),
        ...mapMutations(["setDialog", "setNotification"]),

        localizeDate(date, short) {
            return date
                ? new Date(date).toLocaleString(this.locale, {
                      weekday: short ? undefined : "long",
                      year: "numeric",
                      month: short ? "numeric" : "long",
                      day: "numeric"
                  })
                : "-";
        },

        handleSearch() {
            if (this.page != 1) {
                this.page = 1;
            } else {
                this.getCouponClaims({
                    query: `?q=${this.search}`,
                    id: this.couponId
                });
            }
        },

        fetchData() {
          this.getCouponClaims({
            query: this.query,
            id: this.couponId
          });
          if (this.couponId && this.multipleCoupon?.coupon_id != this.couponId) {
            this.getSingleCoupon(this.couponId)
          }
        },

        async getSingleCoupon(id){
            if (!id) {
                return null
            }
            this.multipleCoupon = this.multipleCoupons?.find(x => x.coupon_id == id)
            if (!this.multipleCoupon?.coupon_id) {
                let page = 1
                while (!this.multipleCoupon?.coupon_id && page <= this.pagination?.total_pages) {
                    await this.getItems('?page='+page)
                    this.multipleCoupon = this.multipleCoupons.find(x => x.coupon_id == id)
                    page++
                }
            }
        }
    },

    mounted() {
        this.fetchData()
        this.getExportedFile();
       
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
       
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.replace({
                query: {
                    page: 1,
                    ...this.$route.query
                }
            });
        }
    },

    beforeDestroy() {
        clearInterval(this.getExportedFileInterval)
    }
};
</script>

<style>
.coupon-actions .v-skeleton-loader__actions {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    min-height: 42px;
}
.coupon-actions.category-loader .v-skeleton-loader__actions {
    height: 300px;
}
.coupon-actions .v-skeleton-loader__actions .v-skeleton-loader__button {
    height: auto;
    width: auto;
    min-width: 64px;
    width: 100%;
}

.coupon-actions.category-loader
    .v-skeleton-loader__actions
    .v-skeleton-loader__button {
    width: 400px;
    border-radius: 24px;
    margin-right: 40px !important;
}

.coupon-actions
    .v-skeleton-loader__actions
    .v-skeleton-loader__button:last-child {
    margin-right: 0 !important;
}
</style>

<style scoped>
.border-grey {
    border: 2px solid grey;
}

.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}

.icon-container {
    /* margin-top:20px; */
    height: 200px;
    width: 200px;
}
.select-category {
    cursor: pointer;
    transition: all 0.5s ease-out;
    background-color: white;
    min-width: 200px;
    font-size: 22px;
    color: gray;
    /* border: 1px solid black */
}
.select-category:hover {
    background-color: rgba(0, 0, 0, 0.2);
    color: black;
    /* font-size: 26px; */
}

.invisible {
    opacity: 0;
    z-index: 0;
}

.overlapped {
    position: absolute;
}

.transition-all {
    transition: all 1.5s, width 2s, max-width 1s, min-width 1s, margin-left 2s,
        margin-top 2.5s, background-position 1.5s, opacity 1s,
        background-color 2s;
}
.back-button {
    position: absolute;
    top: 45%;
    z-index: 10;
}
.mw-100 {
    min-width: 100% !important;
}
.mw-180 {
    min-width: 180px !important;
}
.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
